const STORAGE_KEY = "zg.lowBandwidth";

type Listener = (lowBandwidth: boolean) => void;
const listeners = new Set<Listener>();

function safeRead(): boolean | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw === null ? null : raw === "1";
  } catch {
    return null;
  }
}

/**
 * Guess whether this device wants fewer effects.
 *
 * A 2G/3G connection or a phone reporting very few cores is exactly the
 * audience this event is for, so default them into the lighter mode rather
 * than making them find a toggle after the venue already feels bad.
 */
function detectDefault(): boolean {
  const connection = (
    navigator as Navigator & {
      connection?: { effectiveType?: string; saveData?: boolean };
    }
  ).connection;

  if (connection?.saveData) return true;
  if (connection?.effectiveType && /^(slow-)?2g$/.test(connection.effectiveType)) return true;
  if (typeof navigator.hardwareConcurrency === "number" && navigator.hardwareConcurrency <= 2) {
    return true;
  }
  return false;
}

let lowBandwidth = safeRead() ?? detectDefault();

export function isLowBandwidth(): boolean {
  return lowBandwidth;
}

export function setLowBandwidth(value: boolean): void {
  if (value === lowBandwidth) return;
  lowBandwidth = value;
  try {
    window.localStorage.setItem(STORAGE_KEY, value ? "1" : "0");
  } catch {
    /* preference is a convenience, not a requirement */
  }
  for (const listener of listeners) listener(value);
}

export function onLowBandwidthChange(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
